exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#doc-manager #metadata .metadata-container .button{float:right}#doc-manager #metadata .metadata-container .action-button{z-index:2;padding:5px 10px;margin-top:30px;border-radius:5px;position:absolute;background:#fff;border:.5px solid rgba(0,0,0,.2)}#doc-manager #metadata .metadata-container .action-button .hover:hover{background-color:#f4f7ff}#doc-manager #metadata .metadata-container .action-button:hover{background:#007bff;color:#fff}#doc-manager #metadata .metadata-container .actions-mw{width:98px}#doc-manager #metadata .metadata-container .topic-mw{width:24%}", ""]);

// exports
